import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "./ui/button";
import { Mic, CalendarClock, Heart, Loader2 } from "lucide-react";
import { API } from "../App";
import { useRecording } from "../lib/recording";
import { startRecordedSession } from "../lib/startSession";
import { formatDateSafe } from "../lib/formatDate";

const when = (m) => (m > 1 ? `dans ${m} min` : m >= -1 ? "maintenant" : `commencée il y a ${-m} min`);

// Rappel « pensez à enregistrer » : RDV Calendly imminent (ou en cours) sans transcription ni enregistrement actif. patientId = filtre pour la fiche patient.
const SessionReminderCard = ({ patientId, compact }) => {
  const recording = useRecording();
  const { session } = recording;
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [lead, setLead] = useState(5);
  const [starting, setStarting] = useState("");
  useEffect(() => {
    const load = () => axios.get(`${API}/appointments/soon`, { withCredentials: true }).then((r) => { setItems(r.data.appointments); setLead(r.data.pre_session_minutes); }).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);
  if (session) return null;
  const shown = items.filter((a) => !a.has_transcript && a.minutes_until <= lead && (!patientId || a.patient_id === patientId));
  if (shown.length === 0) return null;
  const start = async (a) => {
    setStarting(a.id);
    await startRecordedSession({ recording, navigate, patientId: a.patient_id, patientName: a.patient_name, appointmentId: a.id });
    setStarting("");
  };
  return (
    <div className={`rounded-xl border border-rose-300 bg-rose-50/70 dark:bg-rose-950/20 ${compact ? "p-3" : "p-4"} space-y-2`} data-testid="session-reminder-card">
      <p className="text-sm font-semibold flex items-center gap-2 text-rose-800 dark:text-rose-200"><CalendarClock className="w-4 h-4" /> {shown.length > 1 ? "Séances imminentes — pensez à lancer l'enregistrement" : "Séance imminente — pensez à lancer l'enregistrement"}</p>
      {shown.map((a) => (
        <div key={a.id} className="flex flex-col sm:flex-row sm:items-center gap-2 rounded-lg border bg-background px-3 py-2" data-testid={`session-reminder-${a.id}`}>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium truncate flex items-center gap-1.5">{a.couple && <Heart className="w-3.5 h-3.5 text-rose-500 shrink-0" />}{a.patient_name || "Patient"} <span className="text-xs font-normal text-muted-foreground">· {formatDateSafe(a.start_time, { hour: "2-digit", minute: "2-digit" })} · {when(a.minutes_until)}</span></p>
            {a.event_name && <p className="text-xs text-muted-foreground truncate">{a.event_name}</p>}
          </div>
          <Button size="sm" onClick={() => start(a)} disabled={!!starting} className="gap-1.5 shrink-0 bg-rose-600 hover:bg-rose-700" data-testid={`session-reminder-start-${a.id}`}>{starting === a.id ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mic className="w-4 h-4" />} Lancer l'enregistrement</Button>
        </div>
      ))}
    </div>
  );
};

export default SessionReminderCard;
